var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE2AtticRoomBis(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54 34h7v22h-7V34zm-28 0h24v22H26V34zm8 8h8v-4h-8v4zM15 56h7V34h-7v22zm44-33H17a5 5 0 00-4.73 5v2H22v-4h4v4h24v-4h4v4h10v-2a5 5 0 00-5-5z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E2_Attic_room_bis.bce723c6.svg";
export { SvgE2AtticRoomBis as ReactComponent };